module.exports = __webpack_public_path__ + "994d2d3522a7fdd4cc015ffa8a62840e.svg";